export default import.meta.ROLLDOWN_FILE_URL_8Bi2fBXDUU9l1YHw65Yvzg